import { useState } from 'react';
import styled from 'styled-components';
import ReviewDownIcon from '@/assets/mo/review-down.svg?react';
import ReviewUpIcon from '@/assets/mo/review-up.svg?react';
import WaterIcon from '@/assets/mo/water.svg?react';
import TherapyIcon from '@/assets/mo/therapy.svg?react';
import FeeIcon from '@/assets/mo/fee.svg?react';
import AppointmentIcon from '@/assets/mo/free-appointment.svg?react';

const SummaryCard = () => {
  const [open, setOpen] = useState(false);
  return (
    <CardContainer>
      <HeaderRow>
        <HeaderText>요즘 다들 이만큼 받았어요</HeaderText>
        <ToggleButton onClick={() => setOpen(!open)}>
          {open ? <ReviewUpIcon /> : <ReviewDownIcon />}
        </ToggleButton>
      </HeaderRow>

      <CardContent>
        <ListBox>
          <ItemBox>
            <ItemLeft>
              <WaterIcon />
              <ItemTextGroup>
                <ItemTitle>누수</ItemTitle>
                <ItemSub>최근 많은</ItemSub>
              </ItemTextGroup>
            </ItemLeft>
            <ItemRight>평균 167만원 보험금 수령</ItemRight>
          </ItemBox>
        </ListBox>
        {open && (
          <>
            <ListBox>
              <ItemBox>
                <ItemLeft>
                  <FeeIcon />
                  <ItemTextGroup>
                    <ItemTitle>진단금/기타</ItemTitle>
                    <ItemSub>HOT</ItemSub>
                  </ItemTextGroup>
                </ItemLeft>
                <ItemRight>평균 2900만원 보험금 수령</ItemRight>
              </ItemBox>
            </ListBox>

            <ListBox>
              <ItemBox>
                <ItemLeft>
                  <AppointmentIcon />
                  <ItemTextGroup>
                    <ItemTitle>무료선임</ItemTitle>
                    <ItemSub>HOT</ItemSub>
                  </ItemTextGroup>
                </ItemLeft>
                <ItemRight>평균 157만원 보험금 수령</ItemRight>
              </ItemBox>
            </ListBox>

            <ListBox>
              <ItemBox>
                <ItemLeft>
                  <TherapyIcon />
                  <ItemTextGroup>
                    <ItemTitle>도수치료</ItemTitle>
                    <ItemSub>HOT</ItemSub>
                  </ItemTextGroup>
                </ItemLeft>
                <ItemRight>평균 89만원 보험금 수령</ItemRight>
              </ItemBox>
            </ListBox>
          </>
        )}
      </CardContent>
    </CardContainer>
  );
};

export default SummaryCard;

// ====================== styled-components ======================

const CardContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 28px 16px 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: 16px;
  background: #f5f7f9;
`;

const HeaderRow = styled.div`
  display: flex;
  height: 48px;
  padding-left: 4px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  width: 100%;
`;

const HeaderText = styled.div`
  color: var(--gray-ui_gray01, #191919);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.36px;
`;

const ToggleButton = styled.button`
  all: unset; /* 기본 버튼 스타일 제거 */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardContent = styled.div`
  display: flex;
  padding-bottom: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  width: 100%;
`;

const ListBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const ItemBox = styled.div`
  display: flex;
  height: 68px;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  background: #fff;
  width: 100%;
`;

const ItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ItemTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ItemTitle = styled.div`
  color: var(--gray-ui_gray03, #3a3a3a);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const ItemSub = styled.div`
  display: flex;
  padding: 2px 0px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  color: var(--gray-ui_gray05, #999);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.2px;
`;

const ItemRight = styled.div`
  color: var(--Primary-brand_01, #0b46dd);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;
